import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { PrType, ProductTypeService } from '../../services/product-type.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-update-pr-type',
  templateUrl: './update-pr-type.component.html',
  styleUrls: ['./update-pr-type.component.css']
})
export class UpdatePrTypeComponent implements OnInit,OnDestroy {

  errorCode: boolean;

  prTypeForm: FormGroup;
  sid: string;
  prType: any;

  constructor(
    private prTypeService: ProductTypeService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    let sub = this.prTypeService.getPrType(this.sid).subscribe(data => {
      sub.unsubscribe();
      this.prType = data;
      this.prTypeForm.get('name').setValue(data.name);
      this.prTypeForm.get('description').setValue(data.description);
      this.prTypeForm.get('code').setValue(data.code);
    });
  }

  ngOnDestroy() {
  }

  createForm() {
    this.prTypeForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      code: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.selection = 'venta';
    let sub = this.prTypeService.codeExistVenta(value.code).subscribe(data => {
      sub.unsubscribe();
      if((data.length && data[0].id == this.sid) || !data.length){
        this.prTypeService.updatePrType(this.sid, value);
      }else{
        this.errorCode=true;
      }
      
    });
    
  }

}
